import type { AxiosInstance } from 'axios'

import { CreateBlogInputInterface } from '../../interfaces/blog'

export const createBlog = (api: AxiosInstance) => (
  blogDetail: CreateBlogInputInterface
) => api.post('/v1.0/admin/blogs', blogDetail)
